// src/components/messages/VideoCall.jsx
import React, { useState, useEffect, useRef } from 'react';
import { FaMicrophone, FaMicrophoneSlash, FaVideo, FaVideoSlash, FaExpand, FaCompress, FaPhoneSlash } from 'react-icons/fa';
import webrtcService from '../../services/webrtc';
import './videoCall.css';

const VideoCall = ({ onClose, targetName, targetAvatar }) => {
  const [muted, setMuted] = useState(false);
  const [videoEnabled, setVideoEnabled] = useState(true);
  const [fullscreen, setFullscreen] = useState(false);
  const localVideoRef = useRef(null);
  const remoteVideoRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    // Récupérer les streams depuis webrtcService
    const localStream = webrtcService.localStream;
    const remoteStream = webrtcService.remoteStream;
    if (localVideoRef.current && localStream) {
      localVideoRef.current.srcObject = localStream;
    }
    if (remoteVideoRef.current && remoteStream) {
      remoteVideoRef.current.srcObject = remoteStream;
    }
  }, []);

  const toggleMute = () => {
    if (webrtcService.localStream) {
      const audioTrack = webrtcService.localStream.getAudioTracks()[0];
      if (audioTrack) {
        audioTrack.enabled = !audioTrack.enabled;
        setMuted(!audioTrack.enabled);
      }
    }
  };

  const toggleVideo = () => {
    if (webrtcService.localStream) {
      const videoTrack = webrtcService.localStream.getVideoTracks()[0];
      if (videoTrack) {
        videoTrack.enabled = !videoTrack.enabled;
        setVideoEnabled(videoTrack.enabled);
      }
    }
  };

  const toggleFullscreen = () => {
    if (!containerRef.current) return;
    if (!document.fullscreenElement) {
      containerRef.current.requestFullscreen();
      setFullscreen(true);
    } else {
      document.exitFullscreen();
      setFullscreen(false);
    }
  };

  const endCall = () => {
    webrtcService.endCall();
    onClose();
  };

  return (
    <div className="video-call-container" ref={containerRef}>
      <div className="remote-video">
        <video ref={remoteVideoRef} autoPlay playsInline />
        <div className="remote-info">
          <img src={targetAvatar} alt={targetName} />
          <span>{targetName}</span>
        </div>
      </div>
      <div className="local-video">
        <video ref={localVideoRef} autoPlay playsInline muted />
        <div className="local-controls">
          <button onClick={toggleMute} className={muted ? 'active' : ''}>
            {muted ? <FaMicrophoneSlash /> : <FaMicrophone />}
          </button>
          <button onClick={toggleVideo} className={!videoEnabled ? 'active' : ''}>
            {videoEnabled ? <FaVideo /> : <FaVideoSlash />}
          </button>
          {/* <button onClick={toggleFullscreen}>
            {fullscreen ? <FaCompress /> : <FaExpand />}
          </button> */}
          <button onClick={endCall} className="end-call">
            <FaPhoneSlash />
          </button>
        </div>
      </div>
    </div>
  );
};

export default VideoCall;